var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"config-text-row"},[_c('span',{staticClass:"config-text-row__plan"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"config-text-row__value"},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }